import { definedDatePickerRanges, getRangeByName } from '../utils/dateRanges';

ko.bindingHandlers.dateRangePicker = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        const $element = $(element);

        const initialValue = ko.unwrap(valueAccessor());

        let start = initialValue[0]; //moment().utc().subtract(100, 'years');//moment().subtract(60, 'days');
        let end = initialValue[1]; //moment().utc();//moment();

        function cb(start, end, range) {
            $element.find('span').html(range && range != 'Custom Range' ? range : start.format('L') + ' - ' + end.format('L'));

        }

        $element.daterangepicker({
            startDate: start,
            endDate: end,
            minDate: moment('2020-01-01'),
            ranges: definedDatePickerRanges,
            opens: 'left'
        }, cb);

        $element.on('apply.daterangepicker', function (ev, picker) {
            valueAccessor()([picker.startDate, picker.endDate, picker.chosenLabel])
        });

        cb(start, end, initialValue[2]);
    }
};